import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { PageTitle } from '../../components/ui';
import Loader from '../../components/elements/loader';
import Container from '../../components/elements/container';
import { TableSkeletion } from '../../components/elements/skeletions';
import { TextField } from '../../components/ui';
import { SearchIcon } from '../../icons';
import { CompanyGroupCard } from '../../components/adminDashboard/companyGroupCard';
import { useGetCompanyGroupDetails, useImpersonateFleetAdmin } from '../../hooks/react-query/useCompanyGroup';

export const GroupOfCompaniesLanding = () => {

    const companyGroupId = localStorage.getItem('companyGroup');
    const { data: groupDetails, isLoading: isMembersLoading } = useGetCompanyGroupDetails(companyGroupId)
    const { mutate: impersonateFleetAdmin, isLoading: isImpersonationLoading} = useImpersonateFleetAdmin();

    const [searchText, setSearchText] = useState('');
    const [selectedAfm, setSelectedAfm] = useState();
    const [filteredData, setFilteredData] = useState()
    const [loading, setLoading ] = useState(true);

    useEffect(()=> {
        if(groupDetails && groupDetails.data && groupDetails.data.members && groupDetails.data.members.length === 1) {
            localStorage.setItem('shouldFallback', true);
            handleLoginAsFleetAdmin(groupDetails.data.members[0].user.id)
        } else if(groupDetails && groupDetails.data && groupDetails.data.members && groupDetails.data.members.length !== 1){
            setLoading(false)
        } 
    }, [groupDetails])

    useEffect(() => {
        if(groupDetails && groupDetails.data && groupDetails.data.members) {
            setFilteredData(groupDetails.data.members);
        }
    }, [groupDetails])

    const handleCardClick = (data) => {
    setSelectedAfm(data.user.afm);
    };
    
    const handleGroupSearch = (value) => {
        setSearchText(value);
        setSelectedAfm(null);

        if (groupDetails?.data?.members) {
            const filteredMembers = groupDetails.data.members.filter((member) => {
              const searchLower = value.toLowerCase(); // Convert search value to lowercase
              return (
                member.user.afm.toLowerCase().includes(searchLower) || // Match AFM
                member.user.company.toLowerCase().includes(searchLower) // Match company
              );
            });
        
            setFilteredData(filteredMembers); // Update the filtered data
          } else {
            setFilteredData([]); // Set to an empty array if no members exist
          }
      };

    const handleLoginAsFleetAdmin = (userid) => {
        impersonateFleetAdmin(userid);
      };

    return (
        <>
            {(isMembersLoading ) && <Loader />}
            { !loading && <Container>
                <PageTitle
                    displaySearch={false}
                    wrapperClassName="flex-col max-lg:px-5"
                    title={
                    <div className="flex justify-between max-lg:gap-x-8 items-center">
                        <div className='flex-col max-lg:gap-x-8'>
                            <h2 className='pb-5'>{groupDetails?.data?.name}</h2>
                            <p>Επίλεξε το ΑΦΜ με το οποίο θέλεις να συνεχίσεις ως Διαχειριστής Στόλου:</p>
                        </div>
                        <div className="grid lg:grid-cols-1 pb-5 gap-10 my-auto max-lg:gap-4">
                            <TextField
                                wrapperClass={clsx('flex-1', "searchClassName")}
                                className={
                                    'h-full rounded-full text-body border-none items-center px-5 lg:py-4 py-3'
                                }
                                placeholder={'Αναζήτηση'}
                                value={searchText}
                                onChange={(e) => {handleGroupSearch(e.target.value)}}
                                icon={<SearchIcon />}
                                />
                        </div>
                    </div>
                    }
                    endComponent={
                        <div>
                            {filteredData?.length > 0 ? <div className='grid grid-cols-2 gap-4'> 
                                {
                                    (filteredData || []).map((member) => { 
                                        return <div > 
                                                <CompanyGroupCard 
                                                    key = {member.id}
                                                    handleCardClick={(e) => handleCardClick(member.user.afm)}
                                                    member={member}
                                                    selectedAfm={selectedAfm}
                                                    handleEnterClick={handleLoginAsFleetAdmin}/>
                                            </div> 
                                        })
                                }
                            </div>
                                : <div className='w-full text-start mt-5'>
                                    Κανένα αποτέλεσμα
                                </div>
                            }
                        </div>
                    }
                />
            </Container>}
        </>
    );
}